import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PrivateApi from "../../services/PrivateApiService";
import { Button, Col, Container, Form, FormControl, Row } from "react-bootstrap";
import { useQuery } from "react-query";
import SplashPage from "../SplashPage";
import ErrorPage from "../ErrorPage";
import TopSwitchAnlageCard from "../../components/anlage/TopSwitchAnlageCard";
import { FaArrowUp, FaHouseUser, FaLightbulb, FaPlusCircle } from "react-icons/fa";
import QuickAccessCard from "../../components/shared/QuickAccessCard";
import { BsBuildingsFill } from "react-icons/bs";
import RegisterExistingAnlageModal from "../../components/anlage/RegistarExistingAnlageModal";
import ChangeAnlageModal from "../../components/anlage/ChangeAnlageModal";
import HwNewAnlageModal from "../../components/anlage/new/modals/HwNewAnlageModal";


const BuildingAnlagenPage = () => {

    const { building_id, energo_nr } = useParams() || null;
    const API = new PrivateApi();
    const [scrollBtnVisible, setScrollBtnVisible] = useState(false);
    const [building, setBuilding] = useState();
    const [tops, setTops] = useState([]);
    const [anlagen, setAnlagen] = useState([]);
    const [elvs, setElvs] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [filteredAnlagen, setFilteredAnlagen] = useState([]);
    const [searchField, setSearchField] = useState("");
    const [topSelected, setTopSelected] = useState("all");

    const [addEditModal, setAddEditModal] = useState(false);
    const [registerModal, setRegisterModal] = useState(false);
    const [changeModal, setChangeModal] = useState(false);

    const [anlageForChange, setAnlageForChange] = useState();
    const [lastSwitch, setLastSwitch] = useState("");

    const [selectedQuickAccess, setSelectedQuickAccess] = useState(1);
    const [quickAccessData, setQuickAccessData] = useState({
        all: { id: 1, count: 0 },
        bestand: { id: 2, count: 0 },
        allgemein: { id: 3, count: 0 }
    });

    const onlyOwnedQuery = ['GET_ALL_BUILDING_INFO_QUERY', building_id, 'onlyOwned'];
    const includeUnOwnedQuery = ['GET_ALL_BUILDING_INFO_QUERY', building_id, 'includeAll'];

    const queryOwned = useQuery({
        queryKey: onlyOwnedQuery,
        queryFn: () => API.get_Anlagen_all_info(building_id),
        staleTime: Infinity,
        enabled: !!building_id && !energo_nr,
    });

    const queryIncludeAll = useQuery({
        queryKey: includeUnOwnedQuery,
        queryFn: () => API.get_Anlagen_including_now_owned(building_id),
        staleTime: Infinity,
        enabled: !!building_id && !!energo_nr,
    });

    const data = energo_nr ? queryIncludeAll.data : queryOwned.data;
    const isLoading = energo_nr ? queryIncludeAll.isLoading : queryOwned.isLoading;
    const error = energo_nr ? queryIncludeAll.error : queryOwned.error;



    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    useEffect(() => {
        if (data && data.data) {
            setBuilding(data.data.building);
            setAnlagen(data.data.anlagen.sort(anlagenSort));
            setElvs(data.data.elvs);
            setTickets(data.data.tickets);
            setFilteredAnlagen(data.data.anlagen.sort(anlagenSort));

            // counts anlagen
            var bestand_count = data.data.anlagen.filter(a => a.x_studio_field_6T9W2 !== "False" || a.x_adresse_abw_top !== "False");
            var allgemein_count = data.data.anlagen.filter(a => a.x_studio_field_6T9W2 === "False" && a.x_adresse_abw_top === "False");
            setQuickAccessData((prev) => ({ ...prev, ['all']: { ...prev['all'], count: data.data.anlagen.length } }))
            setQuickAccessData((prev) => ({ ...prev, ['bestand']: { ...prev['bestand'], count: bestand_count.length } }));
            setQuickAccessData((prev) => ({ ...prev, ['allgemein']: { ...prev['allgemein'], count: allgemein_count.length } }));

            var tempTops = [];
            if (data.data.anlagen && data.data.anlagen.length > 0) {
                data.data.anlagen.map(a => {
                    if (a.x_studio_field_6T9W2 !== "False") {
                        if (!tempTops.includes(a.x_studio_field_6T9W2)) tempTops.push(a.x_studio_field_6T9W2);
                    }
                    if (a.x_adresse_abw_top !== "False") {
                        if (a.x_studio_field_6T9W2 === "False" && !tempTops.includes(a.x_adresse_abw_top)) tempTops.push(a.x_adresse_abw_top);
                    }
                });
                tempTops = tempTops.sort(topSort);
            }
            if (!tempTops.includes("Allgemeine Liegenschaftsteile")) tempTops.push("Allgemeine Liegenschaftsteile");
            setTops(tempTops);
        }
    }, [data])


    useEffect(() => {
        if (filteredAnlagen && filteredAnlagen.length > 0 && energo_nr) {
            const card = document.getElementById(`anlageCard-${energo_nr}`);
            if (card) {
                card.scrollIntoView({behavior: 'smooth', block: 'center'});
                // Remove class first to allow re-triggering
                card.classList.remove('card-glow');

                // Force reflow (restarts the animation)
                void card.offsetWidth;

                card.classList.add('card-glow');
            }
        }
    }, [filteredAnlagen, energo_nr])


    // effect for search change
    useEffect(() => {
        searchHandler();
    }, [searchField]);

    // effect for dropdown change
    useEffect(() => {
        searchHandler();
    }, [topSelected]);

    // Custom sorting function
    const topSort = (a, b) => {
        // Custom comparison for "2a" before numeric values
        const sanitizedA = a.replace(/[^0-9]/g, '');
        const sanitizedB = b.replace(/[^0-9]/g, '');

        // Convert to numbers
        const numA = parseFloat(sanitizedA);
        const numB = parseFloat(sanitizedB);

        // If both are numeric, sort numerically
        if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
        }

        // If one is numeric and the other is not, numeric goes first
        if (!isNaN(numA) && isNaN(numB)) {
            return -1;
        }

        if (isNaN(numA) && !isNaN(numB)) {
            return 1;
        }

        // If both are non-numeric, sort alphabetically
        return sanitizedA.localeCompare(sanitizedB);
    };

    // Custom sorting function
    const anlagenSort = (a, b) => {
        // Check if x_studio_field_6T9W2 is "False" for both objects
        if (a.x_studio_field_6T9W2 === 'False' && b.x_studio_field_6T9W2 === 'False') {
            return 0; // Maintain current order
        }

        // Check if x_studio_field_6T9W2 is "False" for only one object
        if (a.x_studio_field_6T9W2 === 'False') {
            return 1; // Move "False" values to end
        }

        if (b.x_studio_field_6T9W2 === 'False') {
            return -1; // Move "False" values to end
        }

        // Custom comparison for "2a" before numeric values
        const sanitizedA = a.x_studio_field_6T9W2.replace(/[^0-9]/g, '');
        const sanitizedB = b.x_studio_field_6T9W2.replace(/[^0-9]/g, '');

        // Convert to numbers
        const numA = parseFloat(sanitizedA);
        const numB = parseFloat(sanitizedB);

        // If both are numeric, sort numerically
        if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
        }

        // If one is numeric and the other is not, numeric goes first
        if (!isNaN(numA) && isNaN(numB)) {
            return -1;
        }

        if (isNaN(numA) && !isNaN(numB)) {
            return 1;
        }

        // If both are non-numeric, sort alphabetically
        return sanitizedA.localeCompare(sanitizedB);
    };


    const selectHandler = (top) => {
        if (top === "Allgemeine Liegenschaftsteile") {
            const element = document.getElementById(top);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } else {
            const element = document.getElementById(`top-${top}`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        setTopSelected("all");
    }


    // function for search / select
    const searchHandler = () => {
        var tempAnlagen = [...anlagen];
        var tempTops = [];

        if (selectedQuickAccess === 1) {
            tempAnlagen = [...anlagen];
        }
        if (selectedQuickAccess === 2) {
            tempAnlagen = tempAnlagen.filter(a => a.x_studio_field_6T9W2 !== "False" || a.x_adresse_abw_top !== "False");
        }
        if (selectedQuickAccess === 3) {
            tempAnlagen = tempAnlagen.filter(a => a.x_studio_field_6T9W2 === "False" && a.x_adresse_abw_top === "False");
        }

        if (searchField.length > 0) {
            tempAnlagen = tempAnlagen.filter(a =>
                a.x_zaehlernummer_01.toLowerCase().includes(searchField.toLowerCase()) ||
                a.x_zaehlernummer_02.toLowerCase().includes(searchField.toLowerCase()) ||
                a.x_zaehlpunktnummer_01.toLowerCase().includes(searchField.toLowerCase()) ||
                a.x_zaehlpunktnummer_02.toLowerCase().includes(searchField.toLowerCase()) ||
                a.x_bestandseinheitennummer.toLowerCase().includes(searchField.toLowerCase())
            )
        }

        setFilteredAnlagen(tempAnlagen);

        tempAnlagen.map(ta => {
            if (ta.x_studio_field_6T9W2 !== "False" && !tempTops.includes(ta.x_studio_field_6T9W2)) tempTops.push(ta.x_studio_field_6T9W2);
            if (ta.x_studio_field_6T9W2 === "False" && ta.x_adresse_abw_top !== "False" && !tempTops.includes(ta.x_adresse_abw_top)) tempTops.push(ta.x_adresse_abw_top);
            if (ta.x_studio_field_6T9W2 === "False" && ta.x_adresse_abw_top === "False" && !tempTops.includes("Allgemeine Liegenschaftsteile")) tempTops.push("Allgemeine Liegenschaftsteile");
        });
        setTops(tempTops);

        setFilteredAnlagen(tempAnlagen);
    }


    // function for passing anlage to modal
    const changeModalHandler = (anlage) => {
        setAnlageForChange(anlage);
        setChangeModal(true);
    }

    const registerSwitchHandler = (anlage) => {
        setAnlageForChange(anlage);
        setLastSwitch(`switch-${anlage.id}`);
        setRegisterModal(true);
    }


    // function for quickaccess cards click
    const quickAccessHandler = (id) => {
        if (id === 1) {
            setFilteredAnlagen(anlagen);
            setSelectedQuickAccess(id);
            var tempTops = [];
            anlagen.map(anlage => {
                if (anlage.x_studio_field_6T9W2 !== "False" && !tempTops.includes(anlage.x_studio_field_6T9W2)) tempTops.push(anlage.x_studio_field_6T9W2);
                if (anlage.x_adresse_abw_top !== "False" && anlage.x_studio_field_6T9W2 === "False" && !tempTops.includes(anlage.x_adresse_abw_top)) tempTops.push(anlage.x_adresse_abw_top);
                if (anlage.x_adresse_abw_top === "False" && anlage.x_studio_field_6T9W2 === "False" && !tempTops.includes("Allgemeine Liegenschaftsteile")) tempTops.push("Allgemeine Liegenschaftsteile");
            });
            setTops(tempTops);
        }
        if (id === 2) {
            setFilteredAnlagen(anlagen.filter(a => a.x_studio_field_6T9W2 !== "False" || a.x_adresse_abw_top !== "False"));
            setSelectedQuickAccess(id);
            var tempTops = [];
            anlagen.filter(a => a.x_studio_field_6T9W2 !== "False" || a.x_adresse_abw_top !== "False").map(anlage => {
                if (anlage.x_studio_field_6T9W2 !== "False") {
                    if (!tempTops.includes(anlage.x_studio_field_6T9W2)) tempTops.push(anlage.x_studio_field_6T9W2);
                }
                if (anlage.x_studio_field_6T9W2 === "False" && anlage.x_adresse_abw_top !== "False") {
                    if (!tempTops.includes(anlage.x_adresse_abw_top)) tempTops.push(anlage.x_adresse_abw_top);
                }
            });
            setTops(tempTops);
        }
        if (id === 3) {
            setFilteredAnlagen(anlagen.filter(a => a.x_studio_field_6T9W2 === "False" && a.x_adresse_abw_top === "False"));
            setSelectedQuickAccess(id);
            setTops([]);
        }
    }


    // handler to scroll to top
    const scrollTopHandler = () => {
        //window.scrollTo({top: -15, behavior: "smooth"});
        var addressDiv = document.getElementById('address-div');
        if (addressDiv) {
            addressDiv.scrollIntoView({ behavior: "smooth", block: "center" })
        }
    }

    const handleScroll = () => {
        const scrollTop = window.scrollY;

        if (scrollTop > 200) {
            setScrollBtnVisible(false);
        } else {
            setScrollBtnVisible(true);
        }
    };



    const createNewAnlageCard = (ticket) => {
        if (ticket.description.includes('<tbody>')) {
            var anlage_object = {};
            var table = ticket.description.split('<tbody>');
            var rowsAnlage = table?.[2]?.split('<tr>')?.filter(Boolean) || [];

            rowsAnlage.forEach((row) => {
                const matches = row.match(/<td>(.*?)<\/td>/g);
                if (matches && matches.length >= 2) {
                    const key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                    const value = matches[1].replace(/<td>|<\/td>/g, '').trim();

                    if (key === "Energieform") {
                        anlage_object['x_studio_field_3eKe0'] = value;
                    } 
                    if (key === "Anlagenverwendung") {
                        anlage_object['x_anlagenverwendung'] = value;
                    }
                    if (key === "Spezifische Anlagenverwendung") {
                        anlage_object['x_anlagenverwendung_detail'] = value;
                    }
                    if (key === "Zählernummer") {
                        anlage_object['x_zaehlernummer_01'] = value;
                        anlage_object['x_zaehlpunktnummer_01'] = '?';
                        anlage_object['x_lastprofil_01'] = '?';
                    }
                    if (key === "Zweite Zählernummer") {
                        anlage_object['x_zaehlernummer_02'] = value;
                        anlage_object['x_zaehlpunktnummer_02'] = '?';
                        anlage_object['x_lastprofil_02'] = '?';
                    }
                    anlage_object[key] = value;
                    anlage_object['x_studio_field_mWMGR'] = "new";
                }
                if (anlage_object.x_zaehlernummer_02 === undefined) anlage_object.x_zaehlernummer_02 = "";
            })

            if (table[3] !== undefined) {
                const rowsRegister = table[3].split('<tr>').filter(Boolean);
                rowsRegister.forEach((row) => {
                    const matches = row.match(/<td>(.*?)<\/td>/g);
                    if (matches && matches.length >= 2) {
                        const key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                        const value = matches[1].replace(/<td>|<\/td>/g, '').trim();

                        anlage_object[key] = value;
                    }
                })
            }

            return (
                <TopSwitchAnlageCard
                    key={`ticket-${anlage_object.x_zaehlernummer_01}`}
                    building={building}
                    anlage={anlage_object}
                    ticket={[ticket]}
                    inCreation
                />
            )
        }
    }


    if (isLoading) return <SplashPage />

    if (error) return <ErrorPage error={error} />

    return (
        <>
            <Container>
                <Row id="address-div" className="justify-content-center align-items-center">
                    <Col xs="12" md="12" xl="8">
                        <Row className="align-items-center">
                            <Col xs="12" md="12" xl="8" className="text-start">
                                <h4>{data.data.building.name} {tickets.filter(t => t.ticket_type_id[0] === 11).length > 0 && <small className="text-warning">(Verwaltungswechsel)</small>}</h4>
                                <small className="text-muted">Adresse:</small> {`${data.data.building.street}, ${data.data.building.zip} ${data.data.building.city}`} <br />
                                <small className="text-muted">Objektbezeichnung:</small> {data.data.building.x_objektbezeichnung === "False" || data.data.building.x_objektbezeichnung === "" ? "-": data.data.building.x_objektbezeichnung}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="12" md="4" xl="4" className="text-end">
                        <Button
                            onClick={() => { setAnlageForChange(undefined); setAddEditModal(true); }}
                            className="btn-energo rounded-pill"
                        >
                            <FaPlusCircle style={{ marginRight: "10px", marginTop: "-2px" }} size={30} />
                            <span>Neue Anlage hinzufügen</span>
                        </Button>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col xl="4">
                        <QuickAccessCard
                            id={quickAccessData.all.id}
                            key={quickAccessData.all.id}
                            schema="primary"
                            icon={<BsBuildingsFill size={40} />}
                            count={quickAccessData.all.count}
                            title="Alle"
                            desc="Zeige alle Anlagen in diesem Gebäude"
                            isSelected={quickAccessData.all.id === selectedQuickAccess}
                            handler={quickAccessHandler}
                        />
                    </Col>
                    <Col xl="4">
                        <QuickAccessCard
                            id={quickAccessData.bestand.id}
                            key={quickAccessData.bestand.id}
                            schema="energo"
                            icon={<FaHouseUser size={40} />}
                            count={quickAccessData.bestand.count}
                            title="Bestandeinheiten"
                            desc="Zeige Anlagen in Bestandeinheiten"
                            isSelected={quickAccessData.bestand.id === selectedQuickAccess}
                            handler={quickAccessHandler}
                        />
                    </Col>
                    <Col xl="4">
                        <QuickAccessCard
                            id={quickAccessData.allgemein.id}
                            key={quickAccessData.allgemein.id}
                            schema="warning"
                            icon={<FaLightbulb size={40} />}
                            count={quickAccessData.allgemein.count}
                            title="Allgemeine Liegenschaftsteile"
                            desc="Zeige Anlagen für allgemeine Liegenschaftsteile"
                            isSelected={quickAccessData.allgemein.id === selectedQuickAccess}
                            handler={quickAccessHandler}
                        />
                    </Col>
                </Row>
                <Row className="mt-4 text-center" style={{ marginBottom: "100px" }}>
                    <Col xs="12" md="4" xl="4">
                        <Form.Select size="lg" disabled={tops.length === 0} onChange={e => selectHandler(e.target.value)} value={topSelected} className="rounded-pill">
                            <option value="all">Anlage auswählen</option>
                            {tops && tops.length > 0 ?
                                tops.map(t =>
                                    t !== 'Allgemeine Liegenschaftsteile' ?
                                        <option key={`option-${t}`} value={t}>Top {t}</option>
                                        :
                                        <option key={`option-${t}`} value={t}>{t}</option>
                                )
                                : null}
                        </Form.Select>
                    </Col>
                    <Col xs="12" md="4" xl="8" className="text-center">
                        <FormControl size="lg" type="search" onChange={e => setSearchField(e.target.value)} value={searchField} placeholder="Suchen nach Bestandeinheitennummer, Zählernummer, Zählpunktnummer" className="rounded-pill" />
                    </Col>
                </Row>
                {
                    tickets.filter(t => t.ticket_type_id[0] === 17).length > 0 ?
                        <div style={{marginBottom: "150px"}}>
                            <h4 className="text-start">Neu erfasste Anlagen</h4>
                            <hr />
                            {tickets.filter(ticket => ticket.ticket_type_id[0] === 17).map(t =>
                                createNewAnlageCard(t)
                            )}
                        </div>
                        : null
                }

                {
                    filteredAnlagen.filter(fa => fa.x_studio_field_6T9W2 !== "False" || fa.x_adresse_abw_top !== "False").length > 0 ?
                        <>
                            <h4 className="text-start">Anlagen in Bestandeinheiten</h4>
                            <hr />
                            {tops.filter(t => t !== "Allgemeine Liegenschaftsteile").map(top => (
                                <div key={`top-${top}`} id={`top-${top}`} className="mb-5">
                                    <h5>Top {top}</h5>
                                    {filteredAnlagen.filter(fa => fa.x_studio_field_6T9W2 === top || (fa.x_studio_field_6T9W2 === "False" && fa.x_adresse_abw_top === top)).map(anlage => (
                                        <TopSwitchAnlageCard
                                            key={`card-${anlage.id}`}
                                            building={building}
                                            anlage={anlage}
                                            elv={elvs && elvs.length > 0 ? elvs.filter(e => anlage.x_elv_ids.includes(e.id)) : null}
                                            ticket={tickets && tickets.length > 0 ? tickets.filter(t => t.x_anlage_id[0] === anlage.id) : undefined}
                                            changeModal={changeModalHandler}
                                            switchHandler={registerSwitchHandler}
                                        />
                                    ))}
                                </div>
                            ))}
                        </> : null}

                {filteredAnlagen.filter(fa => fa.x_studio_field_6T9W2 === "False" && fa.x_adresse_abw_top === "False").length > 0 ?
                    <div key={"Allgemeine Liegenschaftsteile"} className="mb-5" style={{ marginTop: "150px" }} id="Allgemeine Liegenschaftsteile">
                        <h4 className="text-start">Anlagen in allgemeinen Liegenschaftsteilen</h4>
                        <hr />
                        {filteredAnlagen.filter(fa => fa.x_studio_field_6T9W2 === "False" && fa.x_adresse_abw_top === "False").map(anlage => (
                            <TopSwitchAnlageCard
                                key={`card-${anlage.id}`}
                                building={building}
                                anlage={anlage}
                                elv={elvs && elvs.length > 0 ? elvs.filter(e => anlage.x_elv_ids.includes(e.id)) : null}
                                ticket={tickets && tickets.length > 0 ? tickets.filter(t => t.x_anlage_id[0] === anlage.id) : undefined}
                                changeModal={changeModalHandler}
                                switchHandler={registerSwitchHandler}
                            />
                        ))}
                    </div> :
                    null
                }
            </Container>
            {!scrollBtnVisible ?
                <Button
                    onClick={() => scrollTopHandler()}
                    className="shadow-lg btn-energo"
                    style={
                        {
                            width: "60px",
                            paddingTop: "10px", paddingBottom: "10px",
                            borderRadius: "15px", position: "fixed",
                            bottom: "10%", right: "2%",
                        }}
                >
                    <FaArrowUp size={35} className="text-white" />
                </Button>
                : null}
            <HwNewAnlageModal show={addEditModal} setShow={setAddEditModal} building={data.data.building} />
            {anlageForChange ?
                <>
                    <RegisterExistingAnlageModal
                        show={registerModal}
                        setShow={setRegisterModal}
                        anlage={anlageForChange}
                        elv={elvs.filter(e => anlageForChange.x_elv_ids.includes(e.id))}
                        lastSwitch={lastSwitch}
                    />
                    <ChangeAnlageModal anlage={anlageForChange} show={changeModal} setShow={setChangeModal} />
                </>
                : null
            }
        </>
    )
}

export default BuildingAnlagenPage;